<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconUser.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>操作人管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="100px" label-position="right" class="search-form">
        <el-form-item label="编号">
          <el-input v-model="filters.doctorNo" clearable></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="filters.doctorName" clearable></el-input>
        </el-form-item>
        <el-form-item label="当日状态">
          <el-select v-model="filters.status" placeholder="请选择当日状态" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否排班">
          <el-select v-model="filters.isScheduling" placeholder="请选择是否排班" clearable>
            <el-option v-for="item in schedulOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="filters.cityCode" placeholder="请选择区域" clearable>
            <el-option v-for="item in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <div class="checkButton">
          <el-form-item label="添加时间">
            <el-date-picker v-model="filters.startTime" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="query(1)">查询</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div>
      </div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="doctorNo" label="编号"></el-table-column>
        <el-table-column prop="doctorName" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="workStatus" label="当日状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.workStatus==1">早班</span>
            <span v-if="scope.row.workStatus==2">中班</span>
            <span v-if="scope.row.workStatus==3">晚班</span>
            <span v-if="scope.row.workStatus==4">休息</span>
            <span v-if="scope.row.workStatus==5">日/休</span>
            <span v-if="scope.row.workStatus==6">休/日</span>
            <div v-if="scope.row.workStatus==7">
              <div>时间段</div>
              <div v-for="(item,index) in scope.row.timeSlot" :key='index'>
                <div>{{item}}</div>
              </div>
            </div>

          </template>
        </el-table-column>
        <el-table-column prop="isScheduling" label="是否排班"></el-table-column>
        <el-table-column prop="cityName" label="区域"></el-table-column>
        <el-table-column prop="updateTime" label="最后操作时间"></el-table-column>
        <el-table-column prop="userName" label="操作人"></el-table-column>
        <el-table-column align="center" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="small" type="primary" @click="handleShow(scope.row,scope.$index)">排班详情
            </el-button>
            <el-button size="small" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <!-- 新增和修改弹框 -->
    <el-dialog :visible.sync="dialogFormVisible" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" ref="formData" label-width="120px" :rules="rules">
        <el-form-item label="区域">
          <el-select :disabled="disabled" v-model="formData.cityCode" style="width: 80%">
            <el-option v-for="(item,index) in citys" :key="index" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作人姓名">
          <el-input v-model="formData.doctorName" style="width:80%">
          </el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="formData.mobile" style="width:80%" maxlength="11">
          </el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="formData.departmentId" @focus="departmentFocus" :remote-method="departmentRemoteMethod" filterable remote clearable placeholder="请输入搜索部门" style="width:80%" @input="testSX">
            <el-option v-for="item in departmentOptions" :key="item.departmentId" :label="item.departmentName" :value="item.departmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设置排班">
          <div class="calendar">
            <div>
              <el-checkbox-group v-model="radio" @change="onChange" :disabled="disabled">
                <el-checkbox false-label='null' true-label="3" name="state" class="night">晚班</el-checkbox>
                <el-checkbox false-label='null' true-label="1" name="state" class="morning">早班</el-checkbox>
                <el-checkbox false-label='null' true-label="4" name="state" class="rest">休息</el-checkbox>
                <el-checkbox false-label='null' true-label="5" name="state" class="timeRest">日/休</el-checkbox>
                <el-checkbox false-label='null' true-label="6" name="state" class="restTime">休/日</el-checkbox>
                <el-checkbox false-label='null' true-label="7" name="state" class="timeDay">时间段</el-checkbox>
              </el-checkbox-group>
            </div>
            <el-calendar v-model="valueTime">
              <template slot="dateCell" slot-scope="scope">
                <div @click="calClick(scope)" class="squadSelect" :class="scope.data.day==idx ? 'is-selected' : ''">
                  <p v-if="scope.data.day.substr(-2) < 10">{{ scope.data.day.substr(-1)}}</p>
                  <p v-else>{{ scope.data.day.substr(-2)}}</p>
                  <div v-for="(item,index) in doctorSchedule" :key="index">
                    <div :class="item.workStatus=='早班'?'morSelect':item.workStatus=='晚班'?'nightSelect':item.workStatus=='休息'?'restSelect':item.workStatus=='日/休'?'rest_day':item.workStatus=='休/日'?'day_rest':item.workStatus=='时间段'?'time_rest':''" v-if="(item.years).indexOf( scope.data.day.split('-').slice(0)[0])!=-1 && (item.months).indexOf( scope.data.day.split('-').slice(1)[0])!=-1 && (item.days).indexOf( scope.data.day.split('-').slice(2).join('-'))!=-1" class="squad">
                      {{item.workStatus}}
                    </div>
                    <div v-else></div>
                  </div>
                </div>
              </template>
            </el-calendar>
          </div>
          <div class="time" v-if="timeFlag">
            <div v-for="(item,index) in timeSlot" :key="index" class="timeKey">
              <span class="timeSlot">起始时间</span>
              <el-form-item label-width="0px">
                <el-time-select @change="timeChange(radio)" placeholder="起始时间" v-model="item.startTime" :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                }">
                </el-time-select>
              </el-form-item>
              <span>至</span>
              <el-form-item label-width="0px">
                <el-time-select @change="timeChange(radio)" placeholder="结束时间" v-model="item.endTime" :picker-options="{
                  start: '08:30',
                  step: '00:15',
                  end: '18:30',
                  minTime: item.startTime
                }">
                </el-time-select>
              </el-form-item>
              <el-button type="danger" size="mini" @click="delTime(item,index,radio)"><i class="el-icon-delete"></i></el-button>
            </div>
            <el-button style="float:right;" @click="addTime" type="primary" size="mini">添加时间段<i class="el-icon-plus"></i></el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods('formData')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 排班详情 -->
    <el-dialog :visible.sync="SchedulingVisible" width="50%" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formShow">
        <div class="calendar">
          <el-calendar v-model="valueTime">
            <template slot="dateCell" slot-scope="scope">
              <div :class="scope.data.isSelected ? 'is-selected' : ''" class="squadSelect">
                <p v-if="scope.data.day.substr(-2) < 10">{{ scope.data.day.substr(-1)}}</p>
                <p v-else>{{ scope.data.day.substr(-2)}}</p>
                <div v-for="(item,index) in doctorSchedule" :key="index">
                  <div v-if="item.workStatus&&item.workStatus=='时间段'">
                    <el-popover placement="top-start" trigger="hover" popper-class="whatBox">
                      <div v-for="(ele,index) in item.timeSlot" :key="index">
                        <span>{{ele.time}}</span>
                      </div>
                      <div slot="reference">
                        <div v-if="(item.years).indexOf( scope.data.day.split('-').slice(0)[0])!=-1 && (item.months).indexOf( scope.data.day.split('-').slice(1)[0])!=-1 && (item.days).indexOf( scope.data.day.split('-').slice(2).join('-'))!=-1" class="squad time_rest">
                          {{item.workStatus}}
                        </div>
                        <div v-else></div>
                      </div>
                    </el-popover>
                  </div>
                  <div v-if="item.workStatus&&item.workStatus!='时间段'">
                    <div :class="item.workStatus=='早班'?'morSelect':item.workStatus=='晚班'?'nightSelect':item.workStatus=='休息'?'restSelect':item.workStatus=='日/休'?'rest_day':item.workStatus=='休/日'?'day_rest':''" v-if="(item.years).indexOf( scope.data.day.split('-').slice(0)[0])!=-1 && (item.months).indexOf( scope.data.day.split('-').slice(1)[0])!=-1 && (item.days).indexOf( scope.data.day.split('-').slice(2).join('-'))!=-1" class="squad">
                      {{item.workStatus}}
                    </div>
                    <div v-else></div>
                  </div>
                </div>
              </div>
            </template>
          </el-calendar>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="SchedulingVisible = false">取 消</el-button>
        <el-button type="primary" @click="SchedulingVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "member",
  data() {
    return {
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        positionName: "",
      },
      formShow: {
        positionName: "",
      },
      citys: [
        {
          name: '南通',
          cityCode: 2
        },
        {
          name: '上海',
          cityCode: 1
        },
      ],
      cityCode: Lockr.get('cityCode'),
      disabled: false,
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      SchedulingVisible: false,
      instrumentId: '',
      doctorOptions: [],
      departmentOptions: [],
      statusOptions: [{
        value: 1,
        label: '早班'
      }, {
        value: 2,
        label: '中班'
      }, {
        value: 3,
        label: '晚班'
      }, {
        value: 4,
        label: '休息'
      }, {
        value: 5,
        label: '日/休'
      }, {
        value: 6,
        label: '休/日'
      }, {
        value: 7,
        label: '时间段'
      }],
      schedulOptions: [{
        value: 0,
        label: '已排班'
      }, {
        value: 1,
        label: '未排班'
      },],
      formData: {
        data: '',
        content: ''
      },
      radio: 3,
      doctorSchedule: [],
      doctorScheduleEdit: [],
      newdoctorSchedule: [],
      aaa: '',
      active: '',
      rcdata: [],
      valueTime: '',
      disabled: false,
      idx: '',
      test: [],
      startTime: '',
      endTime: '',
      timeSlot: [
        {
          startTime: '',
          endTime: "",
          time: '',
        }
      ],
      timeFlag: false,
      rules: {
        startTime: [
          { required: true, message: '请添加开始时间', trigger: 'blur' },
        ],
        endTime: [
          { required: true, message: '请添加结束时间', trigger: 'blur' },
        ],      }
    }
  },
  methods: {
    testSX() {
      console.log('强制刷新')
      this.$forceUpdate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    // 新增项目
    add() {
      this.timeFlag = false
      this.dialogFormVisible = true
      // 新增置空
      this.formData = {
        cityCode: this.cityCode
      }
      this.instrumentId = ''
      // 弹框日历清空值
      this.radio = ''
      this.doctorSchedule = []
      this.idx = ''
    },
    // 删除项目
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        console.log(item)
        id.push(item.id)
      })
      this.$confirm('确定要删除选中的数据吗？', '删除项目', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/doctor/deleteDoctor", {
            ids: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    // 确定新增
    doAddgoods(formData) {
      //请求新增账号接口
      console.log(this.doctorSchedule)
      console.log(this.formData)
      let empId = Lockr.get("empId")
      var arr = this.doctorSchedule;
      // 提交时删除数组的空元素
      Array.prototype.removeEmptyEle = function (arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i].workStatus == '' || arr[i].workStatus == 'null' || arr[i].workStatus == null) {
            arr.splice(i, 1);
            i = i - 1; // i - 1 ,因为空元素在数组下标 2 位置，删除空之后，后面的元素要向前补位，
          }
        }
        return arr;
      };
      this.test = arr.removeEmptyEle(arr);
      console.log(this.test); //[0,1,2]
      this.$refs[formData].validate((valid) => {
        console.log('valid');
        console.log(valid);
        if (valid) {
          if (!this.instrumentId) {
            // 新增操作人接口
            let data = {
              doctorName: this.formData.doctorName,
              mobile: this.formData.mobile,
              departmentCode: this.formData.departmentId,
              cityCode: this.formData.cityCode,
              doctorSchedule: this.test,
              userId: empId,
            }

            this.departmentOptions.forEach(ele => {
              if (this.formData.departmentId == ele.departmentId) {
                data.departmentName = ele.departmentName
              }
            });
            api.requestQuiet("/doctor/insertDoctorAndSchedule", data, (res) => {
              if (res.result == true) {
                this.dialogFormVisible = false
                // 新增账号接口
                let postData = {
                  userName: this.formData.doctorName,
                  departmentId: this.formData.departmentId,
                  postName: '医生',
                  userId: empId,
                  moblie: this.formData.mobile,
                  // 新建账号0新建操作人1
                  status: 1,
                  doctorNo: res.data.empno,
                  systemType: '1',
                  cityCode: this.formData.cityCode
                }
                api.request("/account/createPersonnelLogin", postData, (res) => {
                  console.log(res.data)
                  _g.toast("success", "新增成功")

                }, (err) => { })
                this.query(this.filters.pagination.page)
              } else {
                _g.toast("error", "新增失败")
                this.query(this.filters.pagination.page)
              }
            }, (err) => { })

          } else {
            this.newdoctorSchedule.forEach(ele => {
              this.doctorScheduleEdit.forEach(item => {
                if (ele.completionTime == item.completionTime) {
                  item.id = ele.id
                }
              });
            });
            let arrOne = this.doctorScheduleEdit;
            Array.prototype.removeEmptyEle = function (arrOne) {
              for (var i = 0; i < arrOne.length; i++) {
                if (arrOne[i].workStatus == '' || arrOne[i].workStatus == 'null' || arrOne[i]
                  .workStatus == null) {
                  arrOne.splice(i, 1);
                  i = i - 1; // i - 1 ,因为空元素在数组下标 2 位置，删除空之后，后面的元素要向前补位，
                }
              }
              return arrOne;
            };
            this.testOne = arrOne.removeEmptyEle(arrOne);
            console.log('this.doctorScheduleEdit')
            console.log(this.doctorScheduleEdit)
            // 修改项目接口
            let data = {
              id: this.instrumentId,
              empno: this.formData.doctorNo,
              doctorName: this.formData.doctorName,
              mobile: this.formData.mobile,
              departmentCode: this.formData.departmentId,
              cityCode: this.formData.cityCode,
              doctorSchedule: this.testOne,
              userId: empId
            }
            this.departmentOptions.forEach(ele => {
              if (this.formData.departmentId == ele.departmentId) {
                data.departmentName = ele.departmentName
              }
            });
            api.requestQuiet("/doctor/updateDoctorAndSchedule", data, (res) => {
              if (res.result == true) {
                this.dialogFormVisible = false
                _g.toast("success", "修改成功")
                this.query(this.filters.pagination.page)
              } else {
                this.dialogFormVisible = false
                _g.toast("error", res.errMsg);
                this.query(this.filters.pagination.page)
              }
            }, (err) => { })
          }        } else {
          _g.toast("warning", '请添加起始时间');
          return false;
        }
      });

    },
    addTime() {
      this.timeSlot.push({
        startTime: '',
        endTime: '',
        key: Date.now()
      })
      this.$forceUpdate()
    },
    delTime(item, listIndex, val) {
      // console.log(val);
      var index = this.timeSlot.indexOf(item)
      if (index !== -1) {
        this.timeSlot.splice(listIndex, 1)
      }
      this.allChange(val)
      this.$forceUpdate()
    },

    handleEdit(index, row) {
      // 点击编辑时数据置空
      this.timeFlag = false
      this.doctorSchedule = []
      this.doctorScheduleEdit = []
      this.idx = ''
      this.valueTime = new Date
      this.radio = ''
      this.dialogFormVisible = true
      this.instrumentId = row.id
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.departmentId = parseInt(this.formData.departmentCode)
      console.log(this.formData)
      let data = {
        id: row.id,
        // doctorScheduleMonth: mydate
      }
      api.request('/doctor/findDoctorSchedule', data, (res) => {
        // console.log(res)
        this.doctorSchedule = res.data
        this.newdoctorSchedule = JSON.parse(JSON.stringify(res.data))
        this.doctorSchedule.forEach(ele => {
          ele.years = ele.completionTime.split('-')[0]
          ele.months = ele.completionTime.split('-')[1]
          ele.days = ele.completionTime.split('-')[2]
          if (ele.workStatus == '早班') {
            ele.status = '1'
          } else if (ele.workStatus == '晚班') {
            ele.status = '3'
          } else if (ele.workStatus == '休息') {
            ele.status = '4'
          } else if (ele.workStatus == '日/休') {
            ele.status = '5'
          } else if (ele.workStatus == '休/日') {
            ele.status = '6'
          } else if (ele.workStatus == '时间段') {
            ele.status = '7'
          }
        });
        // console.log(this.doctorSchedule)
      }, (err) => { })
      this.departmentFocus()
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        doctorNo: this.filters.doctorNo,
        doctorName: this.filters.doctorName,
        status: this.filters.status,
        isScheduling: this.filters.isScheduling,
        cityCode: this.filters.cityCode,
        startTime: '',
        endTime: '',
        page: page,
        size: this.filters.pagination.limit,
      }
      if (this.filters.startTime) {
        querys.startTime = this.filters.startTime[0]
        querys.endTime = this.filters.startTime[1]
      }
      // console.log(querys)
      api.requestQuiet('/doctor/doctorPage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.tableData.forEach(item => {
          if (item.timeSlot) {
            item.timeSlot = item.timeSlot.split(',')
          }
        });
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
      }, (err) => { })
    },
    // 搜索查询全部部位
    departmentRemoteMethod(val) {
      let data = {
        name: val
      }
      api.request('/department/findDepartments', data, (res) => {
        // console.log(res)
        this.departmentOptions = res.data
      }, (err) => { })
    },
    departmentFocus() {
      let data = {
        name: ''
      }
      api.request('/department/findDepartments', data, (res) => {
        // console.log(res)
        this.departmentOptions = res.data
      }, (err) => { })
    },
    calClick(item) {
      // console.log(item)
      // 时间段模块
      this.timeFlag = false

      this.disabled = false
      this.idx = item.data.day
      this.formData.data = item.data.day
      this.radio = ''
      this.rcdata = this.dealMyDate(item.data.day)
      // console.log(this.rcdata)
      // this.radio = this.rcdata.status
      this.doctorSchedule.forEach((ele, index) => {
        if (this.formData.data == ele.completionTime && ele.status) {
          console.log(ele);
          // ele.flag = true
          this.radio = ele.status
          if (ele.status == '7') {
            this.timeFlag = true
          }
          this.timeSlot = ele.timeSlot
          // console.log('this.timeSlot1111111111111');
          // console.log(this.timeSlot);

        }
      });
    },
    timeChange(val) {
      this.allChange(val)
    },
    allChange(val) {
      if (this.formData.data) {
        // this.disabled = true
        var date = this.formData.data.split('-')
        if (val == 1) {
          this.aaa = '早班'
          this.active = 'morningShift'
          this.timeFlag = false
        } else if (val == 3) {
          this.aaa = '晚班'
          this.timeFlag = false
        } else if (val == 4) {
          this.aaa = '休息'
          this.timeFlag = false
        } else if (val == 5) {
          this.aaa = '日/休'
          this.timeFlag = false
        } else if (val == 6) {
          this.aaa = '休/日'
          this.timeFlag = false
        } else if (val == 7) {
          this.aaa = '时间段'
          this.timeFlag = true
          if (this.timeSlot.length != 0) {

          }
        } else if (val == null || val == "null") {
          this.aaa = ''
        }
        var a = {
          years: [date[0]],
          months: [date[1]],
          days: [date[2]],
          completionTime: this.formData.data,
          workStatus: this.aaa,
          status: this.radio,
          timeSlot: this.timeSlot,
        }
        // console.log('aaaaaaaaaaa');
        // console.log(a);
        this.rcdata = this.dealMyDate(a.completionTime)
        if (this.rcdata.status) {
          // console.log('填入的日程', this.doctorSchedule, this.rcdata.radio, a)
          this.$set(this.doctorSchedule, this.rcdata.index, a)
          this.doctorScheduleEdit.forEach((ele, index) => {
            if (ele.completionTime == this.doctorSchedule[this.rcdata.index].completionTime) {
              this.doctorScheduleEdit.splice(index, 1);
            }
          });
          this.doctorScheduleEdit.push(this.doctorSchedule[this.rcdata.index])
          // console.log("修改后的：", this.doctorSchedule)
          // console.log('编辑时修改过的数据this.doctorSchedule[this.rcdata.index]')
          // console.log(this.doctorScheduleEdit)
        } else {
          this.doctorSchedule.push(a)
          this.doctorScheduleEdit.push(a)
          // console.log("this.doctorSchedule0000000000")
          // console.log(this.doctorSchedule)
        }
      } else if (this.formData.data == undefined) {
        _g.toast("warning", "请先选择日期")
        this.disabled = true
      }
      console.log('最终push的数据')
      console.log(this.doctorSchedule)
      // console.log('最终push的数据编辑过的数据')
      // console.log(this.doctorScheduleEdit)
    },
    onChange(val) {
      // console.log('11111');
      // console.log(this.formData.data)
      this.timeSlot = [
        {
          startTime: "",
          endTime: "",
          time: '',
        }
      ]
      this.allChange(val)

    },
    dealMyDate(v) {
      // console.log('v')
      // console.log(v)
      let len = this.doctorSchedule.length
      let res = []
      for (let i = 0; i < len; i++) {
        if (this.doctorSchedule[i].completionTime == v) {
          res.status = this.doctorSchedule[i].status
          res.index = i
          break
        }
      }
      return res
    },

    handleShow(row, index) {
      this.valueTime = new Date
      this.SchedulingVisible = true;
      let data = {
        id: row.id,
        // doctorScheduleMonth: mydate
      }
      api.request('/doctor/findDoctorSchedule', data, (res) => {
        // console.log(res)
        this.doctorSchedule = res.data
        this.doctorSchedule.forEach(ele => {
          ele.years = ele.completionTime.split('-')[0]
          ele.months = ele.completionTime.split('-')[1]
          ele.days = ele.completionTime.split('-')[2]
        });
        console.log(this.doctorSchedule)
      }, (err) => { })
    }
  },
  mounted() {
    /*this.init();*/
    if (this.cityCode && this.cityCode != 'null') {
      this.filters.cityCode = Lockr.get("cityCode")
      this.disabled = true
    } else {
      this.disabled = false
    }
    this.query(this.filters.pagination.page)
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.is-selected {
  color: #1989fa;
  background: #caeafd;
}

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  /* width: 411px; */
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
  width: 96px;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.calendar >>> .el-calendar {
  width: 560px;
}

.calendar >>> .el-calendar-table .el-calendar-day {
  position: relative;
  height: 0px;
  padding: 0;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-form-item__content {
  line-height: 0px;
  border: 1px solid red;
  background: red;
}

.calendar >>> .el-calendar-table td.is-selected {
  border-radius: 1px;
  background: none;
}

.calendar >>> .el-calendar-table td {
  border: none !important;
}

.squad {
  position: absolute;
  top: 11px;
}

.squadSelect {
  width: 48px;
  /* height: 70px; */
  border: 1px solid #eee;
  text-align: center;
}

.night >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #eff6ff;
  border-radius: 8px;
  border: 1px solid #155bd4;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #155bd4;
}

.morning >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #fff9ec;
  border-radius: 8px;
  border: 1px solid #f9a800;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #f9a800;
}

.rest >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #e7e7e7;
  border-radius: 8px;
  border: 1px solid #888888;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #888888;
}
.timeRest >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #b8e4c3;
  border-radius: 8px;
  border: 1px solid #16853b;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #16853b;
}
.restTime >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #eed3e5;
  border-radius: 8px;
  border: 1px solid #f55bc1;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #f55bc1;
}
.timeDay >>> .el-checkbox__label {
  width: 56px;
  height: 56px;
  background: #e9ecba;
  border-radius: 8px;
  border: 1px solid #888888;
  padding: 0;
  text-align: center;
  line-height: 56px;
  color: #888888;
}

.calendar >>> .el-checkbox__inner {
  position: absolute;
  top: 11px;
  left: 41px;
  border-radius: 50%;
  width: 16px;
  height: 16px;
}

.calendar >>> .el-checkbox__inner::after {
  left: 5px;
  top: 2px;
}

.morningShift {
  color: #f9a800;
}

.nightSelect {
  color: #155bd4;
  width: 30px;
  height: 17px;
  background: #eff6ff;
  border-radius: 1px;
  line-height: 17px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.morSelect {
  color: #f9a800;
  width: 30px;
  height: 17px;
  background: #fff9ec;
  border-radius: 1px;
  line-height: 17px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.restSelect {
  width: 30px;
  height: 17px;
  background: #e7e7e7;
  border-radius: 1px;
  color: #888888;
  line-height: 17px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.rest_day {
  width: 30px;
  height: 17px;
  background: #b8e4c3;
  border-radius: 1px;
  color: #16853b;
  line-height: 17px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.day_rest {
  width: 30px;
  height: 17px;
  background: #eed3e5;
  border-radius: 1px;
  color: #f55bc1;
  line-height: 17px;
  font-size: 9px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.time_rest {
  width: 38px;
  height: 17px;
  background: #bcc78f;
  border-radius: 1px;
  color: #888888;
  line-height: 17px;
  font-size: 6px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}
.timeSlot {
  margin-right: 10px;
}
.timeKey {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}
</style>
<style >
.whatBox {
  min-width: 100px !important;
  width: 100px !important;
}
</style>